import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=6ba4a19c&scoped=true&"
import script from "./chatbot.vue?vue&type=script&lang=js&"
export * from "./chatbot.vue?vue&type=script&lang=js&"
import style0 from "./chatbot.vue?vue&type=style&index=0&id=6ba4a19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4a19c",
  null
  
)

export default component.exports